import { render, staticRenderFns } from "./UserRightsManagement.vue?vue&type=template&id=381b6621&scoped=true"
import script from "./UserRightsManagement.vue?vue&type=script&lang=js"
export * from "./UserRightsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b6621",
  null
  
)

export default component.exports